
import { useLanguage } from '@/contexts/LanguageContext';
// FormUtils.ts - Utility functions for forms
// These are pure functions that don't use hooks directly

export const getFormTitle = (formType: string, t: any): string => {
  const normalizedType = formType.toLowerCase();
  
  switch (normalizedType) {
    case 'finance':
    case 'financev1':
      return t('form.finance.title');
    case 'contact':
      return t('form.contact.title');
    case 'offer':
      return t('form.offer.title');
    case 'appointment':
      return t('form.appointment.title');
    case 'service':
      return t('form.service.title');
    case 'carfax':
      return t('form.carfax.title');
    case 'trade':
      return t('form.trade.title');
    default:
      return t('form.default.title');
  }
};

export const shouldShowVehicleInfo = (formType: string): boolean => {
  if (formType === 'Service') return false;
  
  // This function needs to be synchronous, so we'll return false for now
  // The actual vehicle info display should be handled by components that can use async hooks
  return false;
};
